import { Eye, FileCheck, CheckCircle, Shield } from 'lucide-react';

export function VerificationProcess() {
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-10">
        <div className="inline-flex items-center space-x-2 mb-4">
          <Shield className="w-5 h-5 text-indigo-600" />
          <h2 className="text-3xl font-bold text-gray-900">Cómo verificamos las campañas</h2>
        </div>
        <p className="text-gray-600 max-w-2xl mx-auto">
          Cada campaña pública pasa por un proceso de revisión antes de ser visible en el marketplace.
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
        <div className="text-center">
          <div className="bg-indigo-100 w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-4">
            <Eye className="w-7 h-7 text-indigo-600" />
          </div>
          <div className="text-xs font-semibold text-indigo-600 mb-1">Paso 1</div>
          <h3 className="text-lg font-semibold text-gray-900 mb-2">Revisión manual</h3>
          <p className="text-sm text-gray-600">
            Nuestro equipo revisa la información de la campaña, el perfil del organizador y la coherencia de los productos solicitados.
          </p>
        </div>

        <div className="text-center">
          <div className="bg-indigo-100 w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-4">
            <FileCheck className="w-7 h-7 text-indigo-600" />
          </div>
          <div className="text-xs font-semibold text-indigo-600 mb-1">Paso 2</div>
          <h3 className="text-lg font-semibold text-gray-900 mb-2">Validación de contacto</h3>
          <p className="text-sm text-gray-600">
            Verificamos que el organizador tenga datos de contacto reales y accesibles para que los donantes puedan coordinar entregas.
          </p>
        </div>

        <div className="text-center">
          <div className="bg-green-100 w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-4">
            <CheckCircle className="w-7 h-7 text-green-600" />
          </div>
          <div className="text-xs font-semibold text-green-600 mb-1">Paso 3</div>
          <h3 className="text-lg font-semibold text-gray-900 mb-2">Badge de verificación</h3>
          <p className="text-sm text-gray-600">
            Las campañas aprobadas reciben el badge "✓ Verificada" visible para todos los donantes, generando confianza inmediata.
          </p>
        </div>
      </div>
    </section>
  );
}
